"use client";
import type React from "react";
import Ink, { type InkProperties } from "react-ink";

export interface RippleProps extends InkProperties {
  className?: string;
}

export default Ink as unknown as React.FunctionComponent<RippleProps>;
